module.exports = __webpack_public_path__ + "static/media/му.308e806c.mp3";